import React from "react";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import { ErrorField, SubmitButton, } from "../../components/form";
import {
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  useTheme,
} from "@mui/material";
import OutlinedInputComponent from "components/form/outlined-input/OutlinedInput.component";
import AnimateButton from "components/extended/AnimateButton";
import AutocompleteComponent from "components/autocomplete/Autocomplete.component";
import { useTranslation } from "react-i18next";

const AddUserForm = ({
  errors,
  control,
  isSubmitting = false,
  handleSubmit = () => { },
  handleCloseDialog = () => { },
  labelButton,
  title = "",
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      sx={{ height: "100%", width: "100%" }}
    >
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent >
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.email}
              required={true}
              label="Email*"
              {...field}
            />
          )}
        />
        <Controller
          name="firstName"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.name}
              required={false}
              label={`${t('Name')}`}
              {...field}
            />
          )}
        />
        <Controller
          name="lastName"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.lastName}
              required={false}
              label={`${t('Last name')}`}
              {...field}
            />
          )}
        />

        <Controller
          name="role"
          control={control}
          rules={{ required: true }}
          render={({ onChange, field }) => (
            <AutocompleteComponent
              noOptionsText={t('No Options')}
              onChange={onChange}
              options={options}
              name="role"
              required={true}
              label={`${t('Role')}`}
              {...field}
              disableClearable={true}
              defaultValue={options[0]}
              error={errors?.role}
            />
          )}
        />
        {errors?.role ? <ErrorField message={t(errors?.role?.message)} /> : null}

        <Controller
          name="password"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.password}
              required={true}
              type="password"
              label="Password*"
              {...field}
            />
          )}
        />

        <Controller
          name="matchingPassword"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.matchingPassword}
              required={true}
              label={`${t('Confirm password')}*`}
              type="password"
              {...field}
            />
          )}
        />

      </DialogContent>
      <Box m={8} />
      <DialogActions
        sx={{
          zIndex: 999,
          position: "fixed",
          width: "100%",
          maxWidth: 500,
          bottom: 0,
          right: 0,
          backgroundColor:
            theme.palette.mode === "dark" ? theme.palette.dark.dark : "white",
        }}
      >
        <AnimateButton>
          <SubmitButton label={labelButton} isSubmitting={isSubmitting} />
        </AnimateButton>
        <Button variant="text" color="error" onClick={handleCloseDialog}>
          {t('Close')}
        </Button>
      </DialogActions>
    </Box>
  );
};

export default AddUserForm;

const options = [
  { label: "Visitor", value: "visitor" },
  { label: "Operator", value: "operator" },
  { label: "Superuser", value: "superuser" },
];

